import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from '../dashboard_component';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ajaxconfig } from "../ajaxconfig";
import { CbtDataIdGetCbt, CbtDataIdCreateCbt, Deletecbtdata, UpdateCbtDataId } from '../serverurl';

const Cbt = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const navigate = useNavigate();
    const [cbtName, setCbtName] = useState("");
    const [attemptLimit, setAttemptLimit] = useState(1);
    const [accessType, setAccessType] = useState("open_access");
    const [defaultScore, setDefaultScore] = useState(1);
    const [cbtDuration, setCbtDuration] = useState("");
    const [maxQuestion, setMaxQuestion] = useState("");
    const [randomQuestion, setRandomQuestion] = useState("no");
    const [cbtData, setCbtData] = useState([]);
    const [showDuration, setShowDuration] = useState(false);
    const [showAttempt, setShowAttempt] = useState(false);
    const [showScore, setShowScore] = useState(false);
    const [cbtStatus, setCbtStatus] = useState('draft');
    const [buttonActive, setButtonActive] = useState(true);
    const [showConfigModal, setShowConfigModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const config = ajaxconfig();

    const handleToggle = () => setIsCollapsed(!isCollapsed);

    useEffect(() => {
        fetchCbtData();
    }, []);

    const fetchCbtData = () => {
        setLoading(true);
        axios.get(CbtDataIdGetCbt, config)
            .then((response) => {
                setCbtData(response.data.data || []);
                toast.success(response.data.message);
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.message || "Failed to fetch CBT data");
            })
            .finally(() => setLoading(false));
    }

    const submitCbt = (e) => {
        e.preventDefault();
        
        if (!cbtName.trim()) {
            toast.error("CBT Name cannot be empty");
            return;
        }

        const data = {
            'cbt_name': cbtName,
            'attempt_limit': attemptLimit,
            'default_score': defaultScore,
            'cbt_duration': cbtDuration,
            'max_question': maxQuestion,
            'random_question_mode': randomQuestion,   
            'cbt_status': cbtStatus,
            'access_type': accessType,
        }

        setButtonActive(false);
        axios.post(CbtDataIdCreateCbt, data, config)
            .then((response) => {
                setCbtData(prev => [...prev, ...response.data.data]);
                setCbtName("");
                toast.success(response.data.message);
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.message || "Failed to create CBT");
            })
            .finally(() => setButtonActive(true));
    }

    return (
        <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
            <Sidebar isCollapsed={isCollapsed} onToggle={handleToggle} />
            
            <div className={`flex-1 transition-all duration-300 pt-16 lg:pt-5 ${isCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    {/* Header Section */}
                    <div className="mb-8">
                        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                            <div>
                                <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
                                    <div className="p-2 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                        </svg>
                                    </div>
                                    CBT Management
                                </h1>
                                <p className="text-gray-600 mt-2">Create and manage your computer-based tests</p>
                            </div>
                            
                            <div className="flex items-center gap-3 bg-white rounded-xl shadow-sm px-4 py-3">
                                <div className="text-right">
                                    <p className="text-sm font-medium text-gray-900">Total CBTs</p>
                                    <p className="text-2xl font-bold text-blue-600">{cbtData.length}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                        {/* Main Content */}
                        <div className="lg:col-span-2 space-y-8">
                            {/* Create CBT Card */}
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                                <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-4">
                                    <h2 className="text-xl font-bold text-white flex items-center gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                        </svg>
                                        Create New CBT
                                    </h2>
                                </div>
                                
                                <div className="p-6">
                                    <form onSubmit={submitCbt}>
                                        <div className="flex flex-col lg:flex-row gap-4 mb-6">
                                            <div className="flex-grow">
                                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                                    CBT Name
                                                </label>
                                                <input 
                                                    type="text"
                                                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    value={cbtName} 
                                                    onChange={(e) => setCbtName(e.target.value)}
                                                    placeholder="Enter a descriptive name for your CBT"
                                                    required
                                                />
                                            </div>
                                            
                                            <div className="flex gap-3 lg:items-end">
                                                <button 
                                                    className="px-4 py-3 border border-blue-500 text-blue-500 rounded-xl hover:bg-blue-50 transition-all duration-200 flex items-center gap-2 font-medium"
                                                    type="button"
                                                    onClick={() => setShowConfigModal(true)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    </svg>
                                                    Settings
                                                </button>
                                                
                                                <button 
                                                    className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 flex items-center gap-2 font-semibold disabled:opacity-50 disabled:cursor-not-allowed hover:scale-105"
                                                    type="submit"
                                                    disabled={!buttonActive}
                                                >
                                                    {buttonActive ? (
                                                        <>
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                                            </svg>
                                                            Create CBT
                                                        </>
                                                    ) : (
                                                        <>
                                                            <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                            </svg>
                                                            Creating...
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                        
                                        {/* Configurable Fields */}
                                        {(showAttempt || showScore || showDuration) && (
                                            <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                                                <h3 className="text-sm font-semibold text-gray-700 mb-3">Additional Settings</h3>
                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                    {showAttempt && (
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Max Attempts
                                                            </label>
                                                            <input 
                                                                type="number"
                                                                className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                                value={attemptLimit} 
                                                                onChange={(e) => setAttemptLimit(e.target.value)}
                                                                placeholder="Enter attempt limit"
                                                                min="1"
                                                            />
                                                        </div>
                                                    )}
                                                    
                                                    {showScore && (
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Default Score
                                                            </label>
                                                            <input 
                                                                type="number"
                                                                className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                                value={defaultScore} 
                                                                onChange={(e) => setDefaultScore(e.target.value)}
                                                                placeholder="Enter default score"
                                                                min="1"
                                                            />
                                                        </div>
                                                    )}
                                                    
                                                    {showDuration && (
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Duration (seconds)
                                                            </label>
                                                            <input 
                                                                type="number"
                                                                className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                                value={cbtDuration} 
                                                                onChange={(e) => setCbtDuration(e.target.value)}
                                                                placeholder="Enter duration"
                                                                min="1"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </form>
                                </div>
                            </div>
                            
                            {/* CBT List Card */}
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                                <div className="px-6 py-4 border-b border-gray-100">
                                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                                        <h2 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                            </svg>
                                            Your CBTs ({cbtData.length})
                                        </h2>
                                        
                                        {cbtData.length > 0 && (
                                            <div className="flex items-center gap-2 text-sm text-gray-500">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                                Click on CBT name to manage questions
                                            </div>
                                        )}
                                    </div>
                                </div>
                                
                                <div className="p-6">
                                    {loading ? (
                                        <div className="flex flex-col items-center justify-center py-12">
                                            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                                                <svg className="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                            </div>
                                            <p className="text-gray-600 font-medium">Loading your CBTs...</p>
                                        </div>
                                    ) : cbtData.length === 0 ? (
                                        <div className="flex flex-col items-center justify-center py-12">
                                            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                                </svg>
                                            </div>
                                            <h3 className="text-xl font-semibold text-gray-700 mb-2">No CBTs Created Yet</h3>
                                            <p className="text-gray-500 text-center mb-6 max-w-md">
                                                Get started by creating your first computer-based test. Configure settings and add questions to begin.
                                            </p>
                                            <button 
                                                className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 flex items-center gap-2 font-semibold hover:scale-105"
                                                onClick={() => setShowConfigModal(true)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                                </svg>
                                                Create Your First CBT
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                                            {cbtData.map((data, index) => (
                                                <CbtDataCard 
                                                    key={data.cbt_data_id} 
                                                    data={data} 
                                                    index={index}
                                                    refresh={fetchCbtData}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div className="space-y-6">
                            {/* Quick Stats */}
                            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                    </svg>
                                    Quick Stats
                                </h3>
                                
                                <div className="space-y-4">
                                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                        <span className="text-gray-600">Total CBTs</span>
                                        <span className="font-bold text-blue-600">{cbtData.length}</span>
                                    </div>
                                    
                                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                        <span className="text-gray-600">Published</span>
                                        <span className="font-bold text-green-600">
                                            {cbtData.filter(cbt => cbt.cbt_status === 'published').length}
                                        </span>
                                    </div>
                                    
                                    <div className="flex justify-between items-center py-2">
                                        <span className="text-gray-600">Drafts</span>
                                        <span className="font-bold text-yellow-600">
                                            {cbtData.filter(cbt => cbt.cbt_status === 'draft').length}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Tips Card */}
                            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl border border-blue-100 p-6">
                                <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Quick Tips
                                </h3>
                                
                                <ul className="space-y-3 text-sm text-gray-600">
                                    <li className="flex items-start gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-500 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                        Use descriptive names for easy identification
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-500 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                        Set appropriate time limits for your tests
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-500 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                        Configure access settings based on your needs
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Config Settings Modal */}
            {showConfigModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-md">
                        <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-4 rounded-t-2xl">
                            <div className="flex justify-between items-center">
                                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    CBT Configuration
                                </h3>
                                <button 
                                    onClick={() => setShowConfigModal(false)}
                                    className="text-white hover:text-gray-200 transition-colors"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        
                        <div className="p-6 space-y-6">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-3">Duration Settings</label>
                                <div className="flex space-x-4">
                                    <div className="flex items-center">
                                        <input 
                                            type="radio"
                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                                            name="duration_type"
                                            id="duration_no"
                                            onChange={() => setShowDuration(false)}
                                        />
                                        <label htmlFor="duration_no" className="ml-2 text-gray-700">
                                            No Duration Limit
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input 
                                            type="radio"
                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                                            name="duration_type"
                                            id="duration_yes"
                                            onChange={() => setShowDuration(true)}
                                        />
                                        <label htmlFor="duration_yes" className="ml-2 text-gray-700">
                                            Set Duration
                                        </label>
                                    </div>
                                </div>
                            </div>
                            
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-3">CBT Status</label>
                                <div className="flex space-x-4">
                                    <div className="flex items-center">
                                        <input 
                                            type="radio"
                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                                            name="cbt_status"
                                            id="status_published"
                                            checked={cbtStatus === 'published'}
                                            onChange={() => setCbtStatus('published')}
                                        />
                                        <label htmlFor="status_published" className="ml-2 text-gray-700">
                                            Published
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input 
                                            type="radio"
                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                                            name="cbt_status"
                                            id="status_draft"
                                            checked={cbtStatus === 'draft'}
                                            onChange={() => setCbtStatus('draft')}
                                        />
                                        <label htmlFor="status_draft" className="ml-2 text-gray-700">
                                            Draft
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-3">Access Type</label>
                                <div className="flex space-x-4">
                                    <div className="flex items-center">
                                        <input 
                                            type="radio"
                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                                            name="access_type"
                                            id="open_access"
                                            checked={accessType === 'open_access'}
                                            onChange={() => setAccessType('open_access')}
                                        />
                                        <label htmlFor="open_access" className="ml-2 text-gray-700">
                                            Open Access
                                        </label>
                                    </div>
                                    <div className="flex items-center">
                                        <input 
                                            type="radio"
                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                                            name="access_type"
                                            id="close_access"
                                            checked={accessType === 'close_access'}
                                            onChange={() => setAccessType('close_access')}
                                        />
                                        <label htmlFor="close_access" className="ml-2 text-gray-700">
                                            Filtered Access
                                        </label>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="flex justify-end pt-4">
                                <button 
                                    onClick={() => setShowConfigModal(false)}
                                    className="px-5 py-2.5 border border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 transition-colors font-medium"
                                >
                                    Apply Settings
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
}

const CbtDataCard = ({ data, index, refresh }) => {
    const navigate = useNavigate();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [cbtName, setCbtName] = useState(data.cbt_name);
    const [attemptLimit, setAttemptLimit] = useState(data.attempt_limit);
    const [defaultScore, setDefaultScore] = useState(data.default_score);
    const [cbtDuration, setCbtDuration] = useState(data.cbt_duration);
    const [cbtStatus, setCbtStatus] = useState(data.cbt_status);
    const [accessType, setAccessType] = useState(data.access_type);
    const [loading, setLoading] = useState(false);
    const config = ajaxconfig();

    const deleteCbt = () => {
        setLoading(true);
        const deleteData = { cbt_pssc: data.cbt_data_id };
        
        axios.post(Deletecbtdata, deleteData, config)
            .then((response) => {
                toast.success(response.data.message);
                refresh();
            })
            .catch((error) => {
                toast.error(error.message || "Failed to delete CBT");
            })
            .finally(() => {
                setLoading(false);
                setShowDeleteModal(false);
            });
    }

    const saveChanges = () => {
        setLoading(true);
        const updateData = {
            'cbt_name': cbtName,
            'attempt_limit': attemptLimit,
            'default_score': defaultScore,
            'cbt_duration': cbtDuration,
            'cbt_status': cbtStatus,
            'access_type': accessType,
            'cbt_pass_code': data.cbt_data_id,
        }
        
        axios.post(UpdateCbtDataId, updateData, config)
            .then((response) => {
                toast.success(response.data.message);
                refresh();
            })
            .catch((error) => {
                toast.error(error.message || "Failed to update CBT");
            })
            .finally(() => {
                setLoading(false);
                setShowEditModal(false);
            });
    }

    return (
        <>
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 hover:scale-105 overflow-hidden">
                <div className="p-5">
                    <div className="flex justify-between items-start mb-3">
                        <div className="flex-1">
                            <h3 className="font-semibold text-gray-900 text-lg mb-1 line-clamp-2">
                                {data.cbt_name}
                            </h3>
                            <p className="text-sm text-gray-500 mb-2">ID: {data.cbt_data_id}</p>
                        </div>
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                            data.cbt_status === 'published' 
                                ? 'bg-green-100 text-green-800' 
                                : 'bg-yellow-100 text-yellow-800'
                        }`}>
                            {data.cbt_status}
                        </span>
                    </div>
                    
                    <div className="space-y-2 text-sm text-gray-600 mb-4">
                        <div className="flex justify-between">
                            <span>Access Type:</span>
                            <span className="font-medium">{data.access_type === 'open_access' ? 'Open' : 'Filtered'}</span>
                        </div>
                        <div className="flex justify-between">
                            <span>Created:</span>
                            <span className="font-medium">{new Date(data.created_at).toLocaleDateString()}</span>
                        </div>
                        {data.cbt_duration && (
                            <div className="flex justify-between">
                                <span>Duration:</span>
                                <span className="font-medium">{data.cbt_duration}s</span>
                            </div>
                        )}
                    </div>
                    
                    <div className="flex justify-between gap-2">
                        <button 
                            className="flex-1 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-1 text-sm font-medium"
                            onClick={() => navigate(`/cbt_creator/cbt_data?cbt_data_id=${data.cbt_data_id}`)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            {/* Manage */}
                        </button>
                        
                        <button 
                            className="px-3 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-1 text-sm"
                            onClick={() => setShowEditModal(true)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                        </button>
                        
                        <button 
                            className="px-3 py-2 border border-red-300 text-red-600 rounded-lg hover:bg-red-50 transition-colors flex items-center gap-1 text-sm"
                            onClick={() => setShowDeleteModal(true)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            
            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-md">
                        <div className="bg-red-600 text-white px-6 py-4 rounded-t-2xl">
                            <div className="flex justify-between items-center">
                                <h3 className="text-xl font-bold flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                    Confirm Deletion
                                </h3>
                                <button 
                                    onClick={() => setShowDeleteModal(false)}
                                    className="text-white hover:text-gray-200 transition-colors"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        
                        <div className="p-6">
                            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-4">
                                <p className="text-red-800 font-medium">Are you sure you want to delete this CBT?</p>
                                <p className="text-red-700 text-sm mt-1">This action cannot be undone.</p>
                            </div>
                            
                            <div className="border border-gray-200 rounded-xl p-4 bg-gray-50">
                                <p className="mb-1"><span className="font-medium">Name:</span> {data.cbt_name}</p>
                                <p><span className="font-medium">ID:</span> {data.cbt_data_id}</p>
                            </div>
                            
                            <div className="flex justify-end space-x-3 mt-6">
                                <button 
                                    onClick={() => setShowDeleteModal(false)}
                                    className="px-5 py-2.5 border border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 transition-colors font-medium"
                                >
                                    Cancel
                                </button>
                                <button 
                                    onClick={deleteCbt}
                                    disabled={loading}
                                    className={`px-5 py-2.5 rounded-xl text-white flex items-center gap-2 transition-colors font-medium ${
                                        loading ? 'bg-red-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'
                                    }`}
                                >
                                    {loading ? (
                                        <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    ) : (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                        </svg>
                                    )}
                                    Delete Permanently
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            {/* Edit CBT Modal */}
            {showEditModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg">
                        <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-4 rounded-t-2xl">
                            <div className="flex justify-between items-center">
                                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                    Edit CBT
                                </h3>
                                <button 
                                    onClick={() => setShowEditModal(false)}
                                    className="text-white hover:text-gray-200 transition-colors"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        
                        <div className="p-6 space-y-6">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">CBT Name</label>
                                <input 
                                    type="text"
                                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                    value={cbtName}
                                    onChange={(e) => setCbtName(e.target.value)}
                                />
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">CBT Status</label>
                                    <select 
                                        className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                        value={cbtStatus}
                                        onChange={(e) => setCbtStatus(e.target.value)}
                                    >
                                        <option value="published">Published</option>
                                        <option value="draft">Draft</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">Access Type</label>
                                    <select 
                                        className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                        value={accessType}
                                        onChange={(e) => setAccessType(e.target.value)}
                                    >
                                        <option value="open_access">Open Access</option>
                                        <option value="close_access">Filtered Access</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">Duration (seconds)</label>
                                    <input 
                                        type="number"
                                        className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                        value={cbtDuration}
                                        onChange={(e) => setCbtDuration(e.target.value)}
                                        min="1"
                                    />
                                </div>
                            </div>
                            
                            <div className="flex justify-end space-x-3 pt-4">
                                <button 
                                    onClick={() => setShowEditModal(false)}
                                    className="px-5 py-2.5 border border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 transition-colors font-medium"
                                >
                                    Cancel
                                </button>
                                <button 
                                    onClick={saveChanges}
                                    disabled={loading}
                                    className={`px-5 py-2.5 rounded-xl text-white flex items-center gap-2 transition-colors font-medium ${
                                        loading ? 'bg-blue-400 cursor-not-allowed' : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700'
                                    }`}
                                >
                                    {loading ? (
                                        <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    ) : (
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                    )}
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export { Cbt };